import React from 'react';

const PulseBar: React.FC = () => {
    return (
        <div className="h-12 bg-gray-900 border-b border-gray-800 flex items-center justify-between px-6 text-xs font-mono text-gray-400 select-none">
            {/* Left Side: System Indication */}
            <div className="flex items-center gap-6">
                <div className="flex items-center gap-2">
                    <span className="relative flex h-2 w-2">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                    </span>
                    <span className="text-emerald-500 font-bold tracking-wider">SYSTEM: HEALTHY</span>
                </div>

                <div className="flex items-center gap-2">
                    <div className="h-1.5 w-1.5 rounded-full bg-emerald-500"></div>
                    <span>SYNC: OK</span>
                </div>
            </div>

            {/* Right Side: Environment/Time (Placeholder) */}
            <div className="flex items-center gap-4">
                <span className="bg-gray-800 px-2 py-0.5 rounded text-gray-500 border border-gray-700">v2.0.0-beta</span>
                <span>ADMIN::MAIN</span>
            </div>
        </div>
    );
};

export default PulseBar;
